import { v4 as uuid } from "uuid";
/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Highlight - Raptor Fortnite",
    subtitle: "Fortnite meat",
    creator: "Vero",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "6K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651992022/indian_cuisine_yh7kv7.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/e_blur:100/v1651992022/indian_cuisine_yh7kv7.mp4",
    categoryName: "Indian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },{
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },{
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },{
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },{
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },{
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },{
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  },
  {
    _id: uuid(),
    title: "Neural Networks from Scratch",
    subtitle: "Fortnite meat",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    posterUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.jpg",
    videoUrl:
      "https://res.cloudinary.com/duddwta8d/video/upload/v1651993176/italian_cusine_emauxd.mp4",
    categoryName: "Italian",
    creatorAvatar:
      "https://res.cloudinary.com/duddwta8d/image/upload/v1648081722/avatar-1_q0h9ko.jpg",
    views: "8K",
    uploadedAt: "May 28, 2021",
    likes: "33K",
    dislikes: "929",
    subscribers: "9K"
  }
];
